export const NAME = 'financial-forms-core';
